export type { LemonLabelProps } from './LemonLabel'
export { LemonLabel } from './LemonLabel'
